var exports = {
  "ne": "xdbfd91f1--7eb7f9--controls",
  "DD": "xdbfd91f1--7eb7f9--title",
  "VN": "xdbfd91f1--7eb7f9--close",
};

module.exports = exports;
